import React from 'react';

const Categories = ({ height = 24, width = 24, color = '#e6e6e6', secondaryColor = '#b3b3b3' }) => (
  <svg className="svg-icon" xmlns="http://www.w3.org/2000/svg" width={ width } height={ height } viewBox="0 0 24 24">
    <title>Categories</title>
    <g fill={ color }>
      <path d="M22,12.414,11.586,2H3V0h9a1,1,0,0,1,.707.293L23.414,11Z"></path>
      <path d="M20.121,13.707,10.707,4.293A1,1,0,0,0,10,4H2A1,1,0,0,0,1,5v8a1,1,0,0,0,.293.707l9.414,9.414a3,3,0,0,0,4.243,0h0l5.171-5.171a3,3,0,0,0,0-4.243ZM7,12a2,2,0,1,1,2-2A2,2,0,0,1,7,12Z" fill={ color }></path>
    </g>
  </svg>
);

export default Categories;